<div class="centered-container">
  <div class="img-wrapper" [style.height.px]="imgWidth">
    <img src="https://kleksi.com/img/kleksi_logo_anim.png" alt="Kleksi Logo"/>
  </div>
</div>
